<app-con-x-table-page [title]="stackName" [description]="description" eyebrow="Construct-X"
  eyebrowIcon="admin_panel_settings" ariaLabel="Container des ausgewählten Docker-Stacks" locale="de-DE"
  searchPlaceholder="Container oder Service-Typ suchen" countLabel="Container" refreshTooltip="Container aktualisieren"
  loadingMessage="Container werden ermittelt …" errorTitle="Container-Discovery nicht erreichbar"
  retryLabel="Erneut laden" noResultsTitle="Keine passenden Container"
  noResultsDescription="Ändern Sie Suche, Service-Typ oder Statusfilter." [data]="containers" [columns]="columns"
  [actions]="actions" [rowActions]="rowActions" [filters]="filters" [summaryItems]="summaryItems"
  [inspector]="inspector" [selectedRow]="selectedContainer" [emptyState]="emptyState" [loading]="loading"
  [refreshing]="refreshing" [errorMessage]="errorMessage" [refreshable]="true" [pageSize]="25"
  (pageAction)="handlePageAction($event)" (selectedRowChange)="selectedContainer = $event"
  (rowAction)="handleRowAction($event)" (refreshRequested)="refresh()" (retryRequested)="retry()">

  <ng-template appTableCell="baseUrl" let-instance>
    @if (externalUrl(instance); as url) {
    <a class="instance-url" [href]="url" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
      <span>{{ instance.baseUrl }}</span>
      <mat-icon>open_in_new</mat-icon>
    </a>
    } @else if (instance.baseUrl) {
    <span class="instance-url local-url" title="Lokale Adresse – wird nicht im Browser geöffnet">
      <span>{{ instance.baseUrl }}</span>
      <mat-icon>lock</mat-icon>
    </span>
    } @else {
    <span class="missing-value">Nicht geliefert</span>
    }
  </ng-template>
</app-con-x-table-page>